import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/projects/:slug/work-items/new` — legacy entry point. The
 * global `/work-items/new` form (and the in-place
 * `NewWorkItemDialog`) cover work-item creation now; this route
 * just forwards stale URLs to the global form with the project
 * pre-selected, defaulting to the feature type.
 */
export const Route = createFileRoute("/_app/projects/$slug/work-items/new/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/work-items/new/$type",
      params: { type: "feature" },
      search: { project: params.slug },
    });
  },
});
